import styles from "../Editor.module.css";
import InputControl from "../../InputControl/InputControl";

const SkillBody = (props) => {
    const sections = props.sections;
    const skills = ["SKill 1","SKill 2","SKill 3","SKill 4","SKill 5","SKill 6","SKill 7","SKill 8","SKill 9","SKill 10","SKill 11","SKill 12"];

  return (
    <div className={styles.detail}>
    <div className={styles.column}>
      <InputControl
        label="Skill Heading"
        value={props.information[sections.skill].details[props.activeDetailIndex]?.title}
        placeholder="Enter title eg. Languages"
        onChange={(event) =>
          props.setInformation((prev) => ({ ...prev, 
              [sections.skill]: {...prev[sections.skill],
                  details: prev[sections.skill].details.map((detail, index) =>
                    index === props.activeDetailIndex? { ...detail, title: event.target.value } : detail 
                  )
              }
          }))
        }
      />
      <label>Enter Your Skills</label>
      <div className={styles.wrap}>
        {skills.map((ele, index) =>(
          <InputControl
          style={{width:'186px'}}
          placeholder={ele}
          value={props.information[sections.skill].details[props.activeDetailIndex]?.points ? props.information[sections.skill].details[props.activeDetailIndex].points[index] : ""}
          onChange={(event) => 
            props.setInformation((prev) => ({ ...prev, 
              [sections.skill]: {...prev[sections.skill],
                  details: prev[sections.skill].details.map((detail, detailIndex) =>
                    detailIndex === props.activeDetailIndex? {
                      ...detail,
                      points: detail.points.map((point, pointIndex) => 
                        pointIndex === index? event.target.value : point
                      )
                    }: detail
                  ) 
              }
            }))
          }
        />
        ))}
      </div>
    </div>
    </div>
  )
}

export default SkillBody